<template>
  <div>
    <Header v-if="isLaptop === 1" />
    <MobileHeader v-else-if="isLaptop === 2 && showHeader && isValidRoute" />
    <AppMain />
    <Sidebar v-if="isLaptop === 1 && userID" />
  </div>
</template>

<script>
import AppMain from "../../components/Layout/AppMain.vue";
import Header from "@/components/fixedComponents/NewHeader.vue";
import Sidebar from "@/components/fixedComponents/NewSidebar.vue";
import MobileHeader from "../TrainingFolder/FixedComponents/MobileHeader.vue";
import laptopCheck from "../mixin/laptopCheck";
import { eventBus } from "@/utils/eventBus";
import { getProcessedToken } from "@/utils/request";
export default {
  name: "NewLayout",
  components: {
    Header,
    AppMain,
    Sidebar,
    MobileHeader,
  },
  data() {
    return {
      showHeader: true,
      userID: null,
    };
  },
  created() {
    this.userID = getProcessedToken();
  },
  mixins: [laptopCheck],
  computed: {
    isValidRoute() {
      const excludedRoute = ["Instructor", "CourseDetail"];
      return !excludedRoute.includes(this.$route.name);
    },
  },
  mounted() {
    eventBus.$on("toggle-header", (data) => {
      this.showHeader = data;
    });
  },
};
</script>

<style></style>
